module.exports = __webpack_public_path__ + "static/media/itovi_bundle@2x.a8871751.png";